import React, { useEffect, useState } from 'react';
import { Box, Grid, Button, Typography, TextField, Divider, FormControl, Select, MenuItem, FormGroup, FormControlLabel, Checkbox } from '@mui/material';
import CustomTable from '../../components/table/Table';
import { useDispatch, useSelector } from "react-redux";
import SearchButton from '../../components/search/Search';
import BasicTabs from '../../components/tabs/Tabs3';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ClearIcon from '@mui/icons-material/Clear';
import { createregion, createuser, getstate, updateuser } from '../../slices/setting';
import { Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { createfinancier, updatefinanccier } from '../../slices/finance';

const Createfinance = ({setLoader, show}) => {

    const params = useParams();
  
    let { state } = useLocation();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Validation schema using Yup
  const validationSchema = Yup.object({
    financier_name: Yup.string().required('Financier Name is required'),
    address: Yup.string().required('Address is required'),
    city: Yup.string().required('City is required')
  });

  // Initialize Formik
  const formik = useFormik({
    initialValues: {
      financier_name: "",
      address: "",
      city: ""
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const userData = { ...values };
      const c_id = params.userId;
      setLoader(true);
      if (c_id) {
        dispatch(updatefinanccier({c_id, userData}))
          .then(() => {
            navigate("/finance");
            setLoader(false);
          })
          .catch(()=>{
            setLoader(false);
          })
      }
      else{
        dispatch(createfinancier(userData))
        .then(() => {
          navigate("/finance");
          setLoader(false);
        })
        .catch((error) => {
          setLoader(false);
        });
      }

    },
  });

  const arrowBack = () => {
    navigate(-1);
  };

    useEffect(()=>{
      if(state?.viewData){
        formik.setFieldValue('financier_name', state.viewData?.financier_name);
        formik.setFieldValue('address', state.viewData?.address );
        formik.setFieldValue('city', state.viewData?.city );
      }
    }, [formik, state])

  return (
    <div className='content' style={{marginLeft: show ? '220px' : '10px'}}>
      <Box component="form"
        noValidate
        autoComplete="off"
        onSubmit={formik.handleSubmit}>
        <Grid container spacing={3} sx={{ paddingBottom: 2, alignItems: "center" }}>
          <Grid
            item
            xs={12}
            sx={{
              paddingTop: 0,
              display: "flex",
              alignItems: "center",
              gap: 2,
            }}
          >
            <ArrowBackIcon onClick={arrowBack} sx={{ cursor: "pointer" }} />
            <Typography variant="h5">Add Financier</Typography>
          </Grid>
          <Grid item xs={12} sx={{ paddingTop: 3 }}>
            <Grid container spacing={2} sx={{alignItems:'center'}}>
                <Grid item xs={2}>
                  <Typography>Financier Name *</Typography>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    size="small"
                    fullWidth
                    id="financier_name"
                    name="financier_name"
                    variant="outlined"
                    value={formik.values.financier_name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.financier_name && Boolean(formik.errors.financier_name)}
                    helperText={formik.touched.financier_name && formik.errors.financier_name}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Typography>Address *</Typography>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    size="small"
                    fullWidth
                    id="address"
                    name="address"
                    variant="outlined"
                    value={formik.values.address}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.address && Boolean(formik.errors.address)}
                    helperText={formik.touched.address && formik.errors.address}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Typography>City *</Typography>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    size="small"
                    fullWidth
                    id="city"
                    name="city"
                    variant="outlined"
                    value={formik.values.city}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.city && Boolean(formik.errors.city)}
                    helperText={formik.touched.city && formik.errors.city}
                  />
                </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={{mt: 2}}>
          <Grid item xs={12} sx={{textAlign:'end'}}>
            <Button 
              sx={{mr: 2}} 
              variant="outlined" 
              onClick={() => navigate("/usermanagement")}
            >
              Cancel
            </Button>
            <Button 
              type="submit" 
              variant="contained"
            >
              Create New Financier
            </Button>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

export default Createfinance;